import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ISelectedFeatures } from "../../interfaces/i-select-features";

@Injectable({
  providedIn: "root",
})
export class FeaturesSelectedService {
  private featuresClickedSubject = new BehaviorSubject<ISelectedFeatures | null>(null);

  public featuresClicked$ = this.featuresClickedSubject.asObservable();

  setFeaturesClicked(selectedFeatures: ISelectedFeatures): void {
    this.featuresClickedSubject.next(selectedFeatures);
  }

  getFeatureClicked(): ISelectedFeatures | null {
    return this.featuresClickedSubject.getValue();
  }
}
